export default "__VITE_ASSET__92366773__"